import { adminUrl } from 'api/api-constants';
import axios from 'api/axios';
import { useQuery } from '@tanstack/react-query';
import { CACHE_TIME, STALE_TIME } from 'api/const';
import { extractData } from 'api/utils';

export interface CellSpec {
	id: string;
	hashedId: string;
	externalId: string;
	name: string;
	mpnShortName: string;
	devicePrefix: string;
	customerId: string;
	customerExternalId: string;
	customerName: string;
	zitaraDeviceSpecificationId: string;
}

export function getCellSpecs() {
	return axios
		.get<CellSpec[]>('cell_specs', {
			baseURL: adminUrl,
		})
		.then(extractData);
}

export function useGetCellSpecs() {
	return useQuery(['CellSpec', 'list'], () => getCellSpecs(), {
		retry: false,
		cacheTime: CACHE_TIME,
		staleTime: STALE_TIME,
	});
}
